
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IDefaultShippingOrderModel } from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import { searchCustomer } from "@/api/customer";
import { getSuppliersList } from "@/api/inquiry";

import {
  getSalesmanList,
  auditHold,
  removeQuotation,
  generatePI,
  auditPass,
} from "@/api/inquiry";
import {
  getPiList,
  updatePiRemark,
  getPiDeliveryStatus,
  getPiCustomerShipmentStatus,
  confirmOrder,
  invalidPi,
  uncancelPi,
  downloadPiDetail,
} from "@/api/proforma";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
import { QUOTED_STATUS } from "@/constant";
import {UserModule} from "@/store/modules/user";

@Component({
  name: "ViewAllClaims",
  components: {
    Pagination,
    ClaimMaintenance: () => import("./components/claim-maintenance/index.vue"),
    Verification: () => import("./components/verification/index.vue"),
    ViewReceipts: () => import("./components/view-receipts/index.vue"),
    CheckReceipt: () =>
      import(
        "@/views-oms/sales-order-management/order/order-management/components/check-receipt/index.vue"
      ),
    FileManagement: () =>
      import(
        "@/views-oms/sales-order-management/order/order-management/components/file-management/index.vue"
      ),
  },
})
export default class extends Vue {
  @Prop({ default: [] }) private col: [];

  @Watch("col", { immediate: true })
  private async watchData() {
    if (this.col.length) {
      this.tableCol = deepClone(this.col);
    }
  }
  private isShowMore = false;
  private isShowMore2 = false;
  private listLoading = true;
  private showView = false;
  private showClaim = false;
  private isAnnual = false;
  private showReceipt = false;
  private showFile = false;
  private showVer = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [
      {
        id: "123",
      },
    ] as any[],
  };
  public info = {} as any;
  public infoFields = [
    {
      label: "供应商编号",
      key: "customerAbbreviation",
    },
    {
      label: "供应商简称",
      key: "createdTime",
    },
  ] as any;
  public listParam = {
    inquirySheetCode: null,
    customerId: null,
    startTime: null,
    endTime: null,
    sellerId: null,
    status: null,
    time: [],
    time2: [],
  };
  public searchForm = [
    {
      label: "供应商索赔单号",
      prop: "refNumber",
      key: "refNumber",
      type: "input",
      value: "",
      placeholder: "请输入采购订单号",
    },
    {
      label: "生成时间",
      prop: "time",
      key: "time",
      type: "dateTimePicker",
      value: "",
      placeholder: "",
    },
    {
      label: "供应商名称",
      prop: "supplier",
      key: "supplier",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "采购员",
      prop: "refNumber",
      key: "refNumber",
      type: "input",
      value: "",
      placeholder: "请输入采购员",
    },
    {
      label: "销售员",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "请输入销售员",
    },
    {
      label: "采购订单号",
      prop: "refNumber",
      key: "refNumber",
      type: "input",
      value: "",
      placeholder: "请输入采购订单号",
    },
    {
      label: "索赔状态",
      prop: "refTypeId",
      key: "refTypeId",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      // resetKey: { label: "desc", value: "name" },
    },
    {
      label: "索赔类型",
      prop: "refTypeId",
      key: "refTypeId",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      // resetKey: { label: "desc", value: "name" },
    },
  ];
  public tableCol = [
    {
      label: "供应商索赔单号",
      prop: "productQuantity",
      key: "productQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "供应商简称",
      prop: "id",
      key: "id",
      type: "link",
      show: true,
      disabled: false,
    },
    {
      label: "采购员",
      prop: "abbreviation",
      key: "abbreviation",
      show: true,
      disabled: false,
    },
    {
      label: "销售员",
      prop: "saleName",
      key: "saleName",
      show: true,
      disabled: false,
    },
    {
      label: "销售员",
      prop: "productPayMent",
      key: "productPayMent",
      show: true,
      disabled: false,
    },
    {
      label: "索赔产品",
      prop: "conversionProfitMargin",
      key: "conversionProfitMargin",
      show: true,
      disabled: false,
    },
    {
      label: "索赔数量",
      prop: "deposit",
      key: "deposit",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单金额",
      prop: "otherSettlementExpenses",
      key: "otherSettlementExpenses",
      show: true,
      disabled: false,
    },
    {
      label: "索赔金额",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "索赔方式",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "预定抵扣",
      prop: "otherSettlementExpenses",
      key: "otherSettlementExpenses",
      show: true,
      disabled: false,
    },
    {
      label: "索赔抵扣",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "索赔单状态",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "部分抵扣",
          code: "",
          click: "handleDeduction",
        },
      ],
      show: true,
      disabled: false,
      width: 130,
    },
    {
      label: "索赔损耗",
      prop: "otherSettlementExpenses",
      key: "otherSettlementExpenses",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单号",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "生成时间",
      prop: "otherSettlementExpenses",
      key: "otherSettlementExpenses",
      show: true,
      disabled: false,
    },
    {
      label: "附件",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
      length: 255,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "索赔维护",
          code: "",
          click: "handleClaim",
        },
        {
          name: "更多",
          type: "more",
          actions: [
            {
              name: "年度索赔维护",
              code: "",
              click: "handleAnnualClaim",
            },
            {
              name: "查看抵扣单据",
              code: "",
              click: "handleView",
            },
            {
              name: "下载索赔单",
              code: "",
              click: "handleFile",
            },
          ],
        },
      ],
      show: true,
      disabled: false,
      width: 240,
    },
  ] as any;

  created() {
    // this.init();
  }

  activated() {
    // this.init();
  }

  private init() {
    this.getSalesmanList();
    this.searchCustomer();
    this.getPiCustomerShipmentStatus();
    this.getPiDeliveryStatus();
    this.getList();
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.searchForm[2].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const { total, list }: any = await getPiList(params);
    this.table.total = +total;
    this.table.list = list;
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  // 导出excel
  private isExporting = false;

  // 导出
  public handleExport() {
    this.isExporting = true;
    let table = this.tableCol.slice(0, this.tableCol.length - 1);
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.table.list);
    list.forEach((v) => {
      v.shipmentStatus = this.searchForm[7].options.find(
        (item) => item.id === v.shipmentStatus
      ).name;
      v.status = this.searchForm[6].options.find(
        (item) => item.id === v.status
      ).name;
    });
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `PI管理-${new Date()}`
    );
    this.isExporting = false;
  }

  public handleView(scope) {
    this.selectedItem = scope.row;
    this.showView = true;
  }

  public handleVerification(item) {
    this.selectedItem = item;
    this.showVer = true;
  }

  // 查看回执
  public async handleReceipt(scope) {
    // this.selectedItem = scope.row;
    this.showReceipt = true;
  }

  // 文件管理
  public async handleFile(scope) {
    this.selectedItem = scope.row;
    this.showFile = true;
  }

  private handleSuccess() {
    this.showView = false;
    this.showClaim = false;
    this.selectedRows = [];
    (this.$refs.table as any).$refs.table.clearSelection();
    this.getList();
  }

  //  删除
  public async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 审批通过
  public async handleAuditPass(scope) {
    this.$confirm("确定审批通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(scope.row.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "审批通过",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private handlePI(scope) {
    this.$alert(scope.row.approvalRecordId, "PI号码", {
      confirmButtonText: "复制",
      callback: () => {
        this.h5Copy(scope.row.approvalRecordId);
      },
    });
  }

  // 填写备注
  public async handleRemark(item) {
    try {
      let data = {
        remark: item.remark,
      };
      await updatePiRemark(item.id, data);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }

  private h5Copy(content) {
    if (!document.queryCommandSupported("copy")) {
      // 不支持
      return false;
    }
    let textarea = document.createElement("textarea") as any;
    textarea.value = content;
    textarea.readOnly = "readOnly";
    document.body.appendChild(textarea);
    textarea.select(); // 选择对象
    textarea.setSelectionRange(0, content.length); // 核心
    let result = document.execCommand("copy"); // 执行浏览器复制命令
    textarea.remove();
    this.$notify({
      title: "成功",
      message: "复制成功",
      type: "success",
      duration: 2000,
    });
    return result;
  }

  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[4].options = res;
  }

  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[1].options = res;
  }

  private async getPiCustomerShipmentStatus() {
    const res: any = await getPiCustomerShipmentStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[7].options = res;
    this.tableCol.find((item) => item.key === "shipmentStatus").typeList = res;
  }

  private async getPiDeliveryStatus() {
    const res: any = await getPiDeliveryStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[6].options = res;
    this.tableCol.find((item) => item.key === "status").typeList = res;
  }

  public querySearch(data) {
    const params = Object.assign({}, data);
    const { time, time2, ...rest } = params;
    if (time && time.length) {
      rest.piStartTime = time[0];
      rest.piEndTime = time[1];
    }
    if (time2 && time2.length) {
      rest.orderStartTime = time2[0];
      rest.orderEndTime = time2[1];
    }
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  private handleCustomer() {
    // empty
  }

  private linkClick(scope) {
    this.$router.push(`/purchaseOrderDetails?id=${scope.row.id}`);
  }

  public selectedItem = {} as any;

  // 编辑
  public async handleEdit(scope) {
    this.selectedItem = scope.row;
    this.showClaim = true;
  }

  public async handleClaim(scope) {
    this.selectedItem = scope.row;
    this.isAnnual = false;
    this.showClaim = true;
  }

  public async handleAnnualClaim(scope) {
    this.selectedItem = scope.row;
    this.isAnnual = true;
    this.showClaim = true;
  }

  private handleOrderManage(scope) {
    let item = JSON.stringify(scope.row);
    if (item.indexOf("&") != -1) {
      item = item.replace("&", "replace");
    }
    this.$router.push(`/managePurchaseOrders?id=${scope.row.id}&item=${item}`);
  }

  private async handleInvalidPi(scope) {
    this.$confirm("确定作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await invalidPi(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleDeduction(scope) {
    this.$confirm("", "部分抵扣", {
      confirmButtonText: "强制核销",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await this.handleVerification(scope.row);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleUncancelPi(scope) {
    this.$confirm("确定取消作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await uncancelPi(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // 挂起
  private async handleAuditHold(scope) {
    this.$prompt("请输入挂起原因", "挂起", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: scope.row.approvalRecordId,
          remark: value,
        });
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }

  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 点击是否展示所有产品号码
  private showMore() {
    this.isShowMore = !this.isShowMore;
  }

  private showMore2() {
    this.isShowMore2 = !this.isShowMore2;
  }

  private selectedRows: IDefaultShippingOrderModel[] = [];

  private onSelectionChange(rows: IDefaultShippingOrderModel[]) {
    this.selectedRows = rows;
  }
}
